module.exports = __webpack_public_path__ + "components/flag/static/square/ly-1106a6df912e0941fc51a763159e5713.svg";